//dependencias
import React, { Component } from 'react';

//componentes
import MateriasAction from './materias'

class Index extends Component {

    render(){
        return(
            <div>
                <MateriasAction />
            </div>
        );
    }

}
export default Index;